// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Equalizer from "@material-ui/icons/Equalizer";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import MenuItem from "@material-ui/core/MenuItem";

// services
import { MaskDate, validateDate, convertDate, formateDate, formateDateandTime, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioMovimentoEstoque() {
    const { t } = useTranslation();

    useEffect(() => {
        //LoadSelectProduto();
        verifyAcess();
    }, []);

    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);

    const LoadEstabelecimentos = () =>{
        setloadingSelectEstabelecimentos(true);   
        let endPointE = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPointE).then(result=>{      
            if(result.status !== 200)
            {                                     
                showNotification(t('error_message.could_not_load_establishments')+"!",'danger'); 
                setloadingSelectEstabelecimentos(false); 
                return false; 
            }     
            setlistSelectEstabelecimentos(result.data);  
            setloadingSelectEstabelecimentos(false); 
            return true;                
        });  
    }

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setlistSelectEstabelecimentosSelected([{estabelecimentoId:session.estabelecimentoId}]);
            setshowSelectEstabelecimentos(false)
        }
    }

    const [operacaoItem, setOperacaoItem] = React.useState("T");
    const optionsOperacao = [
        { value: 'T', label: 'Todos' },
        { value: 'C', label: 'Compra' },
        { value: 'V', label: 'Venda' },
        { value: 'A', label: 'Ajuste Manual' }
    ];
    const handleOperacaoChange = (value) => {
        setOperacaoItem(value);
    }

    const [tipoMovimentoItem, setTipoMovimentoItem] = React.useState("T");
    const optionsTipoMovimento = [
        { value: 'T', label: 'Todos' },
        { value: 'E', label: 'Entrada' },
        { value: 'S', label: 'Saída' },
    ];
    const handleTipoMovimentoChange = (value) => {
        setTipoMovimentoItem(value);
    }

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    const handleClickPesquisa = () => {
        let data = getValues();

        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate",  t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")

        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
            showNotification(t('error_message.select_3month'), 'danger')
            return false; 
        }

        let obj = {
            estabelecimentoId: session.estabelecimentoId, 
            operacao: operacaoItem,
            tipoMovimento: tipoMovimentoItem,
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida,
        }
        
        loadDados(obj);
    }

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) => {
        setisLoadingList(true);
        const endPoint = "relatorios/relatorioMovimentoEstoque/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);
            return true;
        });
    }

    const columnsProp = [
        {
            Header: t('label.product'),
            filterable: false,
            accessor: "descricaoProduto",
            width: 300,
        },
        {
            Header: t('label.movement'),
            filterable: false,
            accessor: "dataMovimento",
            width: 180,
            Cell : (props)=>{
                const custom_date =  formateDateandTime(props.value);
                return <span>{custom_date}</span>
            },
        },
        {
            Header: t('label.movement_type'),
            filterable: false,
            accessor: "tipoMovimento",
            width: 150,
        },
        {
            Header: t('label.previous_balance'),
            filterable: false,
            accessor: "saldoAnterior",
            width: 150,
        },
        {
            Header: t('label.quantity'),
            filterable: false,
            accessor: "quantidade",
            width: 150,
        },
        {
            Header: t('information_message.current_balance'),
            filterable: false,
            accessor: "saldoAtual",
            width: 150,
        },
        {
            Header: t('information_message.does_the_product_control_stock'),
            filterable: false,
            accessor: "controlaEstoque",
            width: 250,
        },
        {
            Header: t('label.historic'),
            filterable: false,
            accessor: "historico",
            width: 300,
        },
    ]
    const columns = [...columnsProp];
    const [dataCSV, setdataCSV] = React.useState([]);
    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimentoDescricao" },
        { displayName: "Produto", id: "descricaoProduto" },
        { displayName: "Data do movimento", id: "dataMovimento" },
        { displayName: "Tipo do movimento", id: "tipoMovimento" },
        { displayName: "Saldo Aterior", id: "saldoAnterior" },
        { displayName: "Quantidade", id: "quantidade" },
        { displayName: "Saldo Atual", id: "saldoAtual" },
        { displayName: "Controle estoque", id: "controlaEstoque" },
        { displayName: "Histórico", id: "historico" },
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];
        
        data.map(item =>{
            var obj = {
                estabelecimentoDescricao: item.estabelecimentoDescricao,
                descricaoProduto: item.descricaoProduto,
                dataMovimento: formateDateandTime(item.dataMovimento),
                tipoMovimento: item.tipoMovimento,
                saldoAnterior: item.saldoAnterior,
                quantidade: item.quantidade,
                saldoAtual: item.saldoAtual,
                controlaEstoque: item.controlaEstoque,
                historico: item.historico,
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    }

    const classes = useStyles();
    return (
        <>
            <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.stock_movement')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>

                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>                                                               
                                        <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                            {t('label.ini_date')+" *"}  </label>
                                        <Datetime                                    
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}                                    
                                            name="dtini"                                      
                                            defaultValue={dtini}
                                            value={dtini}
                                            onChange={date => { setdtini(date) }}
                                            inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                            className={errors.dtini?"error":""}            
                                        />       
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtini.message} </span>                                                                          
                                        </FormHelperText>} 
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>                                                               
                                        <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                            {t('label.end_date')+" *"}  </label>
                                        <Datetime                                    
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}                                    
                                            name="dtfim"                                      
                                            defaultValue={dtfim}
                                            value={dtfim}
                                            onChange={date => { setdtfim(date) }}
                                            inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                            className={errors.dtfim?"error":""}            
                                        />       
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtfim.message} </span>                                                                          
                                        </FormHelperText>} 
                                    </FormControl>
                                </GridItem>

                                <GridItem xs={12} sm={6} md={3}>
                                    
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                            {
                                                t('label.operation')
                                            } 
                                        </label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.operacaoItem ? true : false)}
                                            isSearchable={true}
                                            name="Operação"
                                            options={optionsOperacao}
                                            value={optionsOperacao.filter(({value}) => value === operacaoItem)}
                                            onChange={(option) => handleOperacaoChange(option.value !== null ? option.value : "Todos") }
                                            placeholder="Todos"
                                            ref={() => register({ name: "Operação" })}
                                        />
                                        {
                                            errors.operacaoItem && 
                                            <FormHelperText className={classes.labelRootError}>
                                                <span> {errors.operacaoItem.message} </span>
                                            </FormHelperText>
                                        } 
                                    </FormControl>
                                    
                                </GridItem>

                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                            {
                                                t('label.movement_type')
                                            } 
                                        </label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.tipoMovimentoItem ? true : false)}
                                            isSearchable={true}
                                            name="Tipo Movimento"
                                            options={optionsTipoMovimento}
                                            value={optionsTipoMovimento.filter(({value}) => value === tipoMovimentoItem)}
                                            onChange={(option) => handleTipoMovimentoChange(option.value !== null ? option.value : "Todos") }
                                            placeholder="Todos"
                                            ref={() => register({ name: "Tipo Movimento" })}
                                        />
                                        {
                                            errors.tipoMovimentoItem && 
                                            <FormHelperText className={classes.labelRootError}>
                                                <span> {errors.tipoMovimentoItem.message} </span>
                                            </FormHelperText>
                                        } 
                                    </FormControl>
                                </GridItem>

                                <GridItem xs={12} sm={6} md={2}>
                                    <Button  round color="primary" 
                                        onClick={e => { handleClickPesquisa()}}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>

                            </GridContainer>
                            {
                                dataCSV.length > 0 &&
                                <div>
                                    <div style={{float:'right'}}>
                                    <CsvDownloader
                                        filename="Relatório Movimento Estoque"
                                        columns={columnsCSV}
                                        datas={dataCSV}
                                        separator={";"}>
                                        <Button  round color="default" size="sm" >
                                            CSV
                                        </Button>
                                    </CsvDownloader>
                                    </div><div style={{clear:'both'}}></div>
                                </div>
                            }
                            <div style={{overflow:'auto',width:'100%'}}>
                                <div style={{minWidth:'1000px'}}> 
                                    {/*  */}
                                    <ReactTable                  
                                        loading = {isLoadingList}
                                        data={list}
                                        filterable
                                        defaultFilterMethod = {noCaseSensitive}
                                        columns={columns}
                                        style={{height: "400px"}}
                                        showPagination={false}
                                        pageSize={list.length}
                                        minRows={5}
                                        className="-striped -highlight"
                                        previousText={t('button.previous')}
                                        nextText={t('button.next')}
                                        loadingText={t('label.loading')+"..."}
                                        noDataText={t('information_message.no_records_found')+"!"}
                                        pageText={t('label.page')}
                                        ofText={t('label.of')}
                                        rowsText={t('label.rows')}
                                    />
                                </div>
                            </div>

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </>
    );
}